import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import ReportDefinitions from "../../../../../common/config/ReportDefinitions";
import ItemOverviewReport from "../../components/ItemOverviewReport";
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from "../redux/selectors/ItemOverviewV1Selectors";

export function ItemOverviewV1Container(props) {
  return (
    <ItemOverviewReport
      reportId={ReportDefinitions.ITEM_OVERVIEW_V1_200.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ItemOverviewV1Container.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ItemOverviewV1Container);
